import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    standalone: false,
  selector: 'integration-apps-oscal-catalog',
  templateUrl: './integration-apps-oscal-catalog.component.html',
  styleUrls: ['./integration-apps-oscal-catalog.component.css'],
})
export class IntegrationAppsOscalCatalogComponent implements OnInit {
  @Input() settingsForm: FormGroup;
  @Input() settings: any;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.settingsForm.addControl(
      'complianceArea',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);
  }
}
